import React from 'react'
import * as Barcode from 'react-barcode'
import * as S from './style'

const ReceivementShelfTag = ({ obj }) => {
  return (
    <>
      <S.TagContainer>
        <S.ContainerTitle>
          <S.Text>{String(obj.batchNumber).padStart(3, '0')}</S.Text>
          <S.Text>DIRETO GONDOLA</S.Text>
        </S.ContainerTitle>
        <S.ContainerInfo>
          <S.Text>Entrada:</S.Text>
          <S.Text>{obj.entryDateAndHour}</S.Text>
        </S.ContainerInfo>
        <S.ContainerBatchId>
          <S.Text>Cod. Lote</S.Text>
          <Barcode
            value={obj.batchId}
            fontSize={13}
            format="CODE39"
            width={1.5}
            height={40}
            marginTop={3}
            marginBottom={6}
          />
        </S.ContainerBatchId>
        <S.ContainerInfo>
          <S.Text>Descrição:</S.Text>
          <S.DescriptionText>{obj.description}</S.DescriptionText>
        </S.ContainerInfo>
        <S.ContainerInfo>
          <S.Text>Modelo:</S.Text>
          <S.DescriptionText>{obj.productCode}</S.DescriptionText>
        </S.ContainerInfo>
        <S.ContainerInfo>
          <S.Text>Cod. Barra:</S.Text>
          <S.DescriptionText>{obj.barcode}</S.DescriptionText>
        </S.ContainerInfo>
        <S.ContainerAddress>
            <S.Text size={18}>{obj.fc}</S.Text>
          <S.AddressBlock>
          <S.Text size={21}>{obj.addressTag}</S.Text>
          </S.AddressBlock>
        </S.ContainerAddress>
      </S.TagContainer>
    </>
  )
}

export { ReceivementShelfTag }
